import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  // Initialize state from localStorage or default to collapsed
  const [isExpanded, setIsExpanded] = useState(() => {
    try {
      const saved = localStorage.getItem('sidebar-expanded');
      return saved ? JSON.parse(saved) : false;
    } catch {
      return false;
    }
  });

  // Right sidebar state - default to collapsed
  const [isRightExpanded, setIsRightExpanded] = useState(() => {
    try {
      const saved = localStorage.getItem('right-sidebar-expanded');
      return saved ? JSON.parse(saved) : false;
    } catch {
      return false;
    }
  });

  // Persist state to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem('sidebar-expanded', JSON.stringify(isExpanded));
    } catch {
      // Ignore localStorage errors
    }
  }, [isExpanded]);

  useEffect(() => {
    try {
      localStorage.setItem('right-sidebar-expanded', JSON.stringify(isRightExpanded));
    } catch {
      // Ignore localStorage errors
    }
  }, [isRightExpanded]);

  const value = {
    isExpanded,
    setIsExpanded,
    isRightExpanded,
    setIsRightExpanded,
    collapsedWidth: 64, // 16 * 4 = 64px (w-16)
    expandedWidth: 256, // 64 * 4 = 256px (w-64)
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};
